const DEFAULT_ITEMS = ["Election Campaigns", "Branding", "PR & Media", "Advertising", "Web & Tech", "Creatives", "Chunavi Geet", "Digital War Room"];

const Separator = ({ className = "text-brand" }) => (
  <svg viewBox="0 0 24 24" className={`mx-8 h-4 w-4 shrink-0 ${className}`} fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" strokeDasharray="3 4" />
    <circle cx="12" cy="12" r="2.5" fill="currentColor" />
  </svg>
);

export default function Marquee({ items = DEFAULT_ITEMS, reverse = false, outline = false, testId = "editorial-marquee" }) {
  return (
    <div className="marquee-wrap select-none overflow-hidden border-y border-white/10 py-6" data-testid={testId}>
      <div className={`marquee-track flex items-center whitespace-nowrap ${reverse ? "marquee-reverse" : ""}`}>
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <span key={i} className="flex items-center">
                <span
                  className={`font-display text-2xl font-semibold uppercase tracking-tight sm:text-3xl lg:text-4xl ${
                    outline ? "text-stroke text-transparent" : "text-paper/90"
                  }`}
                >
                  {item}
                </span>
                <Separator className={outline ? "text-saffron" : "text-brand"} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
